import urlUtils from "@/common/utils/urlUtils";
import ExperienceAttributes from "@/modules/ExperienceAttributes";

class Config extends ExperienceAttributes {
  declare _isIPhone: boolean;
  declare _isMobile: boolean;

  constructor() {
    super(urlUtils.querySettings());
    const ua = navigator.userAgent;
    this._isIPhone = ua.indexOf("iPhone") >= 0 || ua.indexOf("iPod") >= 0;
    this._isMobile =
      this._isIPhone ||
      /Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua) ||
      ua.indexOf("iPad") >= 0 ||
      (navigator.maxTouchPoints > 1 && /Mac|Windows/.test(ua) === false);
  }

  isIPhone() {
    return this._isIPhone;
  }

  /**
   * Device category for video defaults and analytics: 'mobile' | 'desktop'.
   * Uses URL/embed param if set, else derived from navigator.userAgent.
   */
  get device(): "mobile" | "desktop" {
    if (this._attrs.device === "mobile" || this._attrs.device === "desktop") {
      return this._attrs.device;
    }
    return this._isMobile ? "mobile" : "desktop";
  }

  hasMobileExit() {
    return true;
  }

  hasDesktopExit() {
    return this.toBoolean(this._attrs.x, true);
  }
}

export default new Config();
